import { render, staticRenderFns } from "./Dash-stories-card.vue?vue&type=template&id=2af17d0a"
import script from "./Dash-stories-card.vue?vue&type=script&lang=js"
export * from "./Dash-stories-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports